import { createContext } from 'react'
import { createContextualCan } from '@casl/react'
import { TAppAbility } from '../config/ability'

export const AbilityContext = createContext<TAppAbility>(undefined!)

export default createContextualCan(AbilityContext.Consumer)
